import { ActionTypes } from "../actions"
import { EMPTY_OBJECT } from "../../utils/memo"

const translations = (state = {}, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_TRANSLATIONS:
      return action.response
    default:
      return state
  }
}

export default translations

export const getTranslationTexts = (state: any) => state

export const getTranslationTextsByScope = (state: any, scope: string) =>
  state[scope] || EMPTY_OBJECT

// Merged scopes are cached per scope list and recomputed only when the translations are reloaded.
const mergedScopesCache = new Map<string, { source: any; merged: any }>()
export const getTranslationTextsByScopes = (state: any, scopes: string[]) => {
  const key = scopes.join("|")
  const cached = mergedScopesCache.get(key)
  if (cached && cached.source === state) {
    return cached.merged
  }
  const merged = scopes.reduce((accumulator, scope) => {
    return { ...accumulator, ...state[scope] }
  }, {})
  mergedScopesCache.set(key, { source: state, merged })
  return merged
}
